import { Grid, Paper, Stack } from '@mui/material'
import React, { useContext } from 'react'
import ChecklistIcon from '@mui/icons-material/Checklist'
import VDICheckLine from './VDICheckLine'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import EmptyState from '../../../../components/EmptyState/EmptyState'
import { UserContext } from '../../../../App'

const VDICheckForm = ({
  data,
  setData,
  isVehicleCleans,
  selectedCleanType,
  selectedVehicleType,
}) => {
  const { user } = useContext(UserContext)
  const canConfigure =
    user?.security?.isSiteAdmin || user?.employee?.teams?.includes('Fleet')

  const categories = Object.keys(data).filter((x) => x !== 'Comments')

  const visibleItems = (category) =>
    (data?.[category] || [])
      .filter((x) =>
        isVehicleCleans
          ? x.vehicleType.includes(selectedVehicleType)
          : x.applicableTo.includes(selectedVehicleType),
      )
      .filter((x) =>
        isVehicleCleans ? x.cleanType.includes(selectedCleanType) : x,
      )

  const totalVisible = categories.reduce(
    (sum, category) => sum + visibleItems(category).length,
    0,
  )

  if (totalVisible === 0) {
    const checklistName = isVehicleCleans
      ? 'vehicle cleaning checklist'
      : 'VDI checklist'
    const configPath = isVehicleCleans
      ? '/site-configuration/vehicle-cleaning'
      : '/site-configuration/vdi'
    return (
      <EmptyState
        icon={ChecklistIcon}
        title={
          categories.length === 0
            ? `No ${checklistName} configured yet`
            : `No checklist items apply to this vehicle type`
        }
        description={
          categories.length === 0
            ? `This form is built from your organisation's ${checklistName}. ${
                canConfigure
                  ? 'Add the categories and check items in Site Configuration, and they will appear here for crews to complete.'
                  : 'Ask your fleet team or site administrator to configure it — the form will then appear here.'
              }`
            : `Checklist items exist, but none of them are set as applicable to this ${
                isVehicleCleans ? 'vehicle and clean type' : 'vehicle type'
              }. ${
                canConfigure
                  ? 'Review which vehicle types each item applies to in Site Configuration.'
                  : 'Ask your fleet team or site administrator to review which vehicle types each item applies to.'
              }`
        }
        actions={
          canConfigure
            ? [{ label: 'Open Checklist Settings', to: configPath }]
            : []
        }
        docsHref="/docs/fleet-equipment/vdis-and-safety-checks"
      />
    )
  }

  return (
    <Stack gap={1}>
      {categories.map((category) => {
        const items = visibleItems(category)
        if (items.length === 0) return null
        return (
          <Paper sx={{ padding: 1 }} key={category}>
            <DetailsBox title={category}>
              <Grid container spacing={1}>
                {items.map((field) => (
                  <VDICheckLine
                    value={field?.value ?? null}
                    title={field.title}
                    description={field.standard}
                    key={field.title}
                    onChange={(value) =>
                      setData((prev) => {
                        const Ar = prev[category]
                        const index = Ar.findIndex(
                          (x) => x.title === field.title,
                        )
                        Ar[index] = { ...Ar[index], value }
                        return {
                          ...prev,
                          [category]: Ar,
                        }
                      })
                    }
                  />
                ))}
              </Grid>
            </DetailsBox>
          </Paper>
        )
      })}
    </Stack>
  )
}

export default VDICheckForm
